<style>
footer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4rem;
  margin-top: auto;
  border-top: 1px solid #333;
}
</style>

<footer>
  <small>© 2022 HARUTA</small>
</footer>
